import DialingSuccess from 'components/modules/dashboard/DialingSuccess';
import { Col, Row } from 'react-bootstrap';
import DialingPerformanceChart from 'components/charts/DialingPerformanceChart';
import DialingPerformanceChartInbound from 'components/charts/DialingPerformanceChartInbound';
import HVASystemActivityCard from 'components/cards/HVASystemActivityCard';
import ActualCallingKPIs from 'pages/hvamanagement/ActualCallingKPIs';
import ActualCallingKPIsInbound from 'pages/hvamanagement/ActualCallingKPIsInbound';
import CampaignList from 'pages/hvamanagement/CampaignDashboardList';

const ActualCalling = () => {
  return (
    <>
      <Row className="gy-3 mb-6 justify-content-between">
        <Col>
          <h2 className="mb-2 text-body-emphasis">Calling Dashboard</h2>
          <h5 className="text-body-tertiary fw-semibold">
            Here’s what’s going on at your HVA system right now
          </h5>
        </Col>
      </Row>
      <Row className="mb-2 px-3 gy-0">
        <Col xs={12} sm={12} md={12} xl={12} xxl={9}>
          <Row className="mb-1 px-0 gy-6">
            <h4 className="mb-0 p-0 text-body-emphasis">Inbound</h4>
          </Row>
          <Row className="mb-2 px-0 gy-6">
            <Col xs={12} sm={12} md={5} xl={4} xxl={4}>
              <ActualCallingKPIsInbound />
            </Col>
            <Col
              xs={12}
              sm={12}
              md={7}
              xl={8}
              xxl={8}
              className="p-4 pt-0 pb-0"
            >
              <h5 className="text-body-emphasis pt-2">Call handling</h5>
              <p className="text-body-tertiary fs-10 mb-0">
                Offered &amp; handled
              </p>
              <DialingPerformanceChartInbound />
            </Col>
          </Row>
          <Row className="mb-1 px-0 gy-6">
            <h4 className="mb-0 p-0 text-body-emphasis">Outbound</h4>
          </Row>
          <Row className="mb-1 px-0 gy-6">
            <Col xs={12} sm={12} md={5} xl={4} xxl={4}>
              <ActualCallingKPIs />
            </Col>
            <Col
              xs={12}
              sm={12}
              md={7}
              xl={8}
              xxl={8}
              className="p-4 pt-0 pb-0"
            >
              <h5 className="text-body-emphasis pt-2">Dialing success</h5>
              <p className="text-body-tertiary fs-10 mb-0">
                Dialing &amp; answers
              </p>
              <DialingPerformanceChart />
            </Col>
          </Row>
        </Col>
        <Col xs={12} sm={12} md={12} xl={12} xxl={3} className="p-0">
          <HVASystemActivityCard />
        </Col>
      </Row>
      <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 pt-0 pb-3 mb-0 border-bottom">
        <Row>
          <Col xs={12} xl={4} xxl={4}>
            <DialingSuccess title="Dialing success last 30 minutes" value={1} />
          </Col>
          <Col xs={12} xl={4} xxl={4}>
            <DialingSuccess title="Dialing success last hour" value={2} />
          </Col>
          <Col xs={12} xl={4} xxl={4}>
            <DialingSuccess title="Dialing success today" value={3} />
          </Col>
        </Row>
      </div>
      <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis pt-1 mt-0 mb-0">
        <Row className="gy-3 mt-4 justify-content-between">
          <h3 className="mb-2 text-body-emphasis">
            Service/campaign today's performance
          </h3>
          <CampaignList />
        </Row>
      </div>
    </>
  );
};

export default ActualCalling;
